<!-- Ported from the Polaris kit: src/components/ui/spinner/Spinner.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { CircleDash16 as Loader2Icon } from '@carbon/icons-vue';
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <Loader2Icon
    role="status"
    :aria-label="$t('POLARIS.SPINNER.LOADING')"
    :class="cn('size-4 animate-spin p-0', props.class)"
  />
</template>
